<template>
  <div v-if="hasBadges" class="document-badges d-flex align-center flex-wrap">
    <span v-if="isOptional" class="doc-badge doc-badge--optional"
      >Optional</span
    >
    <span v-if="expiryText" class="doc-badge doc-badge--expiry">
      <v-icon size="13" class="mr-1" color="#92400e">{{
        icons.mdiClockOutline
      }}</v-icon>
      {{ expiryText }}
    </span>
  </div>
</template>

<script>
  import { mdiClockOutline } from '@mdi/js';
  import { expiryLabel } from '../../constants/js/testator-documents';

  export default {
    name: 'DocumentBadges',
    props: {
      category: { type: Object, required: true },
    },
    data() {
      return {
        icons: { mdiClockOutline },
      };
    },
    computed: {
      isOptional() {
        return !!this.category.optional;
      },
      expiryText() {
        return expiryLabel(this.category.expiryMonths);
      },
      hasBadges() {
        return this.isOptional || !!this.expiryText;
      },
    },
  };
</script>

<style scoped>
  .document-badges {
    gap: 8px;
    margin-top: 6px;
  }
  .doc-badge {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    padding: 4px 10px;
    border-radius: 999px;
  }
  .doc-badge--expiry {
    color: #92400e;
    background: #fef3c7;
    border: 1px solid #fde68a;
  }
  .doc-badge--optional {
    color: #4b5563;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
  }
</style>
